<script>
  import {getContext} from 'svelte';
  import {numUtil} from '@/helper/num';
  import {gameInfo$, gameStatus$} from '../stream';
  import lang from '../TradeCompetitionPage.lang';

  const LG = getContext('LG');

  function formatDate(t) {
    const time = new Date(t);
    const m = time.getUTCMonth() + 1;
    const d = time.getUTCDate();
    const h = time.getUTCHours();
    const min = time.getUTCMinutes();
    return `${numUtil.pad(m)}-${numUtil.pad(d)} ${numUtil.pad(h)}:${numUtil.pad(min)}`;
  }
</script>

<style>
  .schedule {
    margin-bottom: 40px;
  }
  .rules-content {
    margin: 0;
    padding: 20px;
    font-size: 18px;
  }
  .rules-content li {
    margin: 10px 0;
    line-height: 24px;
  }
  .left-arrow {
    position: absolute;
    left: 0;
    top: 0;
    border-top: 60px solid transparent;
    border-bottom: 60px solid transparent;
    border-left: 20px solid #010612;
  }
  .right-arrow {
    position: absolute;
    right: 0;
    top: 0;
    border-top: 60px solid #010612;
    border-bottom: 60px solid #010612;
    border-left: 20px solid transparent;
  }
  .schedule-section {
    position: relative;
    box-sizing: border-box;
    padding: 22px 0 0 86px;
    width: 402px;
    height: 120px;
    background-color: #192434;
  }
  .schedule-section.current {
    background-color: #095be0;
  }
  .start-time:before,
  .end-time:before {
    content: '';
    display: inline-block;
    margin-right: 6px;
    width: 8px;
    height: 8px;
    background: #fff;
    border-radius: 50%;
  }
  .line {
    top: 10px;
    left: 3px;
    width: 2px;
    height: 20px;
    background: #fff;
  }
  @media screen and (min-width: 640px) {
    .wrap {
      margin: 0 auto 75px;
      width: 1200px;
    }
  }
  @media screen and (max-width: 640px) {
    .wrap {
      margin: 0 auto 40px;
      width: 100%;
    }
    .schedule {
      flex-direction: column;
      justify-content: center;
      padding: 0 20px;
    }
    .schedule-section {
      margin-bottom: 20px;
      width: auto;
    }
    .rules {
      padding: 0 16px;
    }
    .rules-content {
      font-size: 14px;
    }
  }
</style>

<div class="wrap">
  <div class="schedule df jcsb">
    <div class="schedule-section f16 cf {$gameStatus$.isSignUpStart ? 'current' : ''}">
      <div class="right-arrow" />
      <div class="schedule-title">{LG(lang.RegistrationStage)}</div>
      <div class="pr mt10">
        <div class="start-time">{formatDate($gameInfo$.signUpStartTime)} (UTC)</div>
        <div class="end-time">{formatDate($gameInfo$.signUpEndTime)} (UTC)</div>
        <div class="line pa" />
      </div>
    </div>
    <div class="schedule-section f16 cf {$gameStatus$.isCompetitionStart ? 'current' : ''}">
      <div class="left-arrow" />
      <div class="right-arrow" />
      <div class="schedule-title">{LG(lang.CompetitionStage)}</div>
      <div class="pr mt10">
        <div class="start-time">{formatDate($gameInfo$.competitionStartTime)} (UTC)</div>
        <div class="end-time">{formatDate($gameInfo$.competitionEndTime)} (UTC)</div>
        <div class="line pa" />
      </div>
    </div>
    <div class="schedule-section f16 cf {$gameStatus$.isCompetitionEnd ? 'current' : ''}">
      <div class="left-arrow" />
      <div class="schedule-title">{LG(lang.AwardsStage)}</div>
      <div class="pr mt10">
        <div class="start-time">{formatDate($gameInfo$.awardsStartTime)} (UTC)</div>
        <div class="end-time">{formatDate($gameInfo$.awardsEndTime)} (UTC)</div>
        <div class="line pa" />
      </div>
    </div>
  </div>
  <div class="rules">
    <ol class="rules-content cf">
      <li>{LG(lang.Rule1)}</li>
      <li>{LG(lang.Rule2)}</li>
      <li>
        {LG(lang.Rule3)}
        <div>{LG(lang.Rule3_1)}</div>
        <div>{LG(lang.Rule3_2)}</div>
        <div>{LG(lang.Rule3_3)}</div>
      </li>
      <li>{LG(lang.Rule4)}</li>
      <li>{LG(lang.Rule5)}</li>
      <li>{LG(lang.Rule6)}</li>
    </ol>
  </div>
</div>
